import { Typo3SectionSpotSanityPressroom } from '@/types'
import { ContentBlocks } from '@/ui/components'
import { SectionAuthor, SectionCtaSingle, SectionHeroNews } from '@/ui/Sections'
import { memo } from 'react'

interface Props {
  data: Typo3SectionSpotSanityPressroom
}

const Detail = ({ data }: Props) => (
  <>
    <SectionHeroNews
      date={data?.content?.item?.infoPublicationDate}
      title={data?.content?.item?.contentHeader?.title ?? ''}
      leadText={data?.content?.item?.contentHeader?.lead}
      image={data?.content?.item?.images?.[0]}
    />
    <ContentBlocks
      layout="wrapped"
      blocks={data?.content?.item?.contentBlocks}
    />
    <SectionAuthor
      section={data}
      image={data?.content?.item?.images ?? []}
      author={data?.content?.item?.contentAuthor?.author ?? ''}
      text={data?.content?.item?.contentAuthor?.text ?? ''}
    />
    {data?.content?.item?.directoryTeaser &&
      data?.content?.item?.directoryTeaser?.length > 0 && (
        <SectionCtaSingle
          title={data?.content?.item?.directoryTeaser?.[0]?.title}
          body={data?.content?.item?.directoryTeaser?.[0]?.description}
          button={{
            href: data?.content?.item?.directoryTeaser?.[0]?.uri?.href,
            label: data?.content?.item?.directoryTeaser?.[0]?.uri?.title
          }}
          chipContent={data?.content?.item?.directoryTeaser?.[0]?.category}
          image={data?.content?.item?.directoryTeaser?.[0]?.image?.[0]}
          variant="content"
        />
      )}
  </>
)

export default memo(Detail)
